<section class="lg:flex lg:items-center md:sm:grid md:sm:grid-cols-1 gap-4">
  <article class="lg:flex rounded h-10">
    <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" (submitEventEmitter)="search($event)"></app-input-search>
  </article>
  @if (adminRole === 'SUPERADMIN' || adminRole === 'ADMIN') {
    <article class="lg:flex lg:items-center">
      <app-custom-toggle
        [id]="'users-header-toggle'"
        [selectedValue]="userTypeSelected"
        [firstValue]="UserTypes.Regular"
        [secondValue]="UserTypes.Driver"
        [firstImage]="images.suggestions.user"
        [secondImage]="images.suggestions.driver"
        [firstDescription]="literalService.get('users.userTypes.users', true)"
        [secondDescription]="literalService.get('users.userTypes.drivers', true)"
        [color]="'secondary'"
        (action)="changeUserType()"
      />
    </article>
  }
  <article class="relative lg:flex rounded" (click)="filterOpened = !filterOpened">
    <button id="buttonOpenFilter" 
      class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
      [ngClass]="{ 'opened' : filterOpened, 'filtersApplied': filtersApplied > 0 }">
      <img [src]="images.filter" alt="filter" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened': filterOpened || filtersApplied > 0 }" />
      <span class="font-semibold text-base">{{ literalService.get("users.filter", true) }}</span>
    </button>
    @if (filtersApplied > 0) {
      <div class="filter-bubble w-4 h-4 absolute -top-2 -right-2 flex justify-center items-center p-2.5 rounded-full text-xs font-bold">
        {{ filtersApplied }}
      </div>
    }
  </article>
  <article class="flex absolute self-start mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !filterOpened }">
    <app-user-filter [isFilterOpen]="filterOpened" [userType]="userTypeSelected" (filter)="filter.emit($event); updateFilters()" (closeFilter)="filterOpened = false; updateFilters()" [componentOpen]="'buttonOpenFilter'"></app-user-filter>
  </article>
  <article class="relative lg:flex rounded">
    <button id="buttonRowsDisplayOpen"
      class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
      [ngClass]="{ 'opened' : rowsDisplayOpened, 'filtersApplied': rowsDisplayValue !== defaultRowsDisplay }" (click)="rowsDisplayOpened = !rowsDisplayOpened">
      <img [src]="images.visibility" alt="filter" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened': rowsDisplayOpened || rowsDisplayValue !== defaultRowsDisplay }" />
      <span class="font-semibold text-base">{{ `${literalService.get("bookings.show", true)}: ${rowsDisplayValue}` }}</span>
    </button>
    <article class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !rowsDisplayOpened }">
      <app-rows-display [componentOpen]="'buttonRowsDisplayOpen'" [value]="rowsDisplayValue" (close)="rowsDisplayOpened = false" (onChange)="updateNumberOfElements($event)"></app-rows-display>
    </article>
  </article>
  <article id="sort" class="relative lg:flex rounded" (click)="sortedOpened = !sortedOpened">
    <button id="buttonOpenSort" 
      class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
    >
      <img [src]="images.sort" alt="sort" class="w-6 h-6 mr-2" />
      <span class="font-semibold text-base">{{
        literalService.get("users.sort", true)
      }}</span>
    </button>
    <article id="sortModal" class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !sortedOpened }">
      <app-option-selector [id]="'userSortSelector'" [componentOpen]="'buttonOpenSort'" [title]="'orderBy'" [selectedOption]="userSortTypeSelected" [options]="sortOptions" (onChange)="handleSort($event)" (close)="sortedOpened = false" ></app-option-selector>
    </article>
  </article>
  @if (searching) {
    <article class="flex items-center pb-2">
      <img [src]="images.loading" alt="loading" class="h-10 w-10 ml-4" />
      <label class="font-semibold text-base ml-4">{{ literalService.get('users.searchingUsers', true) }}...</label>
    </article>
  }
  <!-- <article class="lg:flex lg:mr-4 rounded mb-2">
    <button class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
      <img [src]="images.visibilityOff" alt="visibilityOff" class="w-6 h-6 mr-2"/>
      <span class="font-normal">{{ literalService.get("users.manageColumns", true) }}</span>
    </button>
  </article>
  <article class="lg:flex lg:mr-4 rounded mb-2 inline-flex items-center">
    <img [src]="images.download" alt="download" class="w-8 h-8 mr-2" />
  </article> -->
  <section class="flex ml-auto gap-4 items-center">
    <!-- TODO: Add roleService.permissions['USER']['CREATE'] when we use me/permissions -->
    @if (userTypeSelected === UserTypes.Driver) {
      <a
        class="rounded-[30px] px-3 py-1.5 inline-flex gap-1 justify-center items-center cursor-pointer outlinedButton"
        (click)="addUserDriverEventEmitter.emit()" 
      >
        <img [src]="images.user.addDriver" alt="addDriver" class="w-5.5 h-5.5" />
        <span class="font-semibold text-base primary-purple-text"> {{ literalService.get('users.newDriver', true) }} </span>
      </a>
    } @else {
      <a
        class="rounded-[30px] px-3 py-1.5 inline-flex gap-1 justify-center items-center cursor-pointer outlinedButton"
        (click)="addUserEventEmitter.emit()" 
      >
        <img [src]="images.user.addUser" alt="addUser" class="w-5.5 h-5.5" />
        <span class="font-semibold text-base primary-purple-text"> {{ literalService.get('users.newUser', true) }} </span>
      </a>
    }
  </section>
</section>
